import React, { Component } from "react";
import SideLink from './sidelink';
import AsideDropDown from './asideDropdown';
import { connect } from 'react-redux'
class AsideBar extends Component {

    render() {
        let customerNo = this.props.loginUsers.customerNo
        // console.log(customerNo)
        let imgIcon = ''
        let imgIconWidth = ''
        switch (customerNo) {
            case 212:
                imgIcon = 'assets/svg/technova.svg'
                imgIconWidth = '50%'
                break;
            case 984:
                imgIcon = 'https://www.poultryindia.co.in/poultry-biz/media/logo_allana1.png'
                imgIconWidth = '60%'
                break;
                case 549:
                    imgIcon = 'assets/img/reema.png'
                    imgIconWidth = '90%'
                    break;
            case 1123:
                imgIcon = 'assets/img/tesa.jpg'
                imgIconWidth = '50%'
                break;
            case 1077:
                imgIcon = 'assets/img/brring.png'
                imgIconWidth = '60%'
                break;
            case 1122:
                imgIcon = 'https://upload.wikimedia.org/wikipedia/en/thumb/b/b9/UPL_official_logo.svg/1200px-UPL_official_logo.svg.png'
                imgIconWidth = '60%'
                break;
            case 1158:
                imgIcon = 'assets/img/snowlink_logo.jpg'
                imgIconWidth = '60%'
                break;
                case 1153:
                    imgIcon = "assets/img/Eonslogo.png";
                    imgIconWidth = "60%";
                    break;
            case 1165:
                    imgIcon = 'assets/img/upl.jfif'
                    imgIconWidth = '60%'
                    break;  
                    case 1166:
                        imgIcon = 'assets/img/upl.jfif'
                        imgIconWidth = '60%'
                        break;  
            case 1305:
                imgIcon = "assets/img/Pidilite_logo.png";
                imgIconWidth = "70%";
                break;
            case 1375:
                    imgIcon = "assets/img/dic.png";
                    imgIconWidth = "70%";
                    break;
            default:
                imgIcon = 'assets/svg/elixia.svg'
                imgIconWidth = "100%"
                break;
        }
        return (
            <React.Fragment>
                <div id="sidebars">
                    <aside id="asidebar" className="sidenav smallSiderbar">
                        <div className="img-thumbnail">
                            <img src={imgIcon}
                                className="sidelogo pt-1"
                                alt="logo"
                                style={{ objectFit: 'contain', display: 'block', marginLeft: 'auto', marginRight: 'auto', width: imgIconWidth }}
                            />
                        </div>
                        <SideLink imgLink="assets/svg/co.svg" linkTo="/transporter-onboarding" linkName="Partner Onboarding" />
                    </aside>
                </div>
            </React.Fragment>
        )
    }
}

const mapStateToProps = ({ loginReducer }) => {
    return loginReducer
};
export default connect(
    mapStateToProps
)(AsideBar);